import 'react-datepicker/dist/react-datepicker.css';
import 'react-calendar/dist/Calendar.css';

import '@/public/assets/css/font-awesome-4.7.0.min.css';

import '@/frontend/src/index.css';
import '@/frontend/src/App.css';
import '@/frontend/src/app/admin-views/financials/Animations.css';

import '@/frontend/src/app/admin-views/financials/Animations.css';
import '@/frontend/src/app/common/fields/dateFieldOverride.css';
import '@/frontend/src/app/common/loading/LoadingPage.css';
import '@/frontend/src/app/common/menus/MenuAppBar.css';

import '@/frontend/src/app/admin-views/tasks/TasksCalendar.css';
import type { AppProps } from 'next/app';
import Head from 'next/head';

const SCRIPT = `
var version = "${process.env.COMMIT_SHA || 'local'}";
var env = "${process.env.APP_ENV || 'local'}";
`;

function getFaviconPath(): string {
  if (process.env.NODE_ENV === 'development') {
    return '/localdev.png';
  }
  if (process.env.APP_ENV === 'stage') {
    return 'staging.png';
  }
  return '/favicon.png';
}

export default function MyApp({ Component, pageProps }: AppProps) {
  return (
    <>
      <Head>
        <title>AI Insurance</title>
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css?family=Open+Sans:300,400,400i,600,600i,700,700i&display=swap"
        />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css?family=Roboto:400,500&display=swap"
        />
        {/* biome-ignore lint/security/noDangerouslySetInnerHtml: hardcoded script with process.env values only */}
        <script dangerouslySetInnerHTML={{ __html: SCRIPT }} />
        <link rel="icon" type="image/png" href={getFaviconPath()} />
      </Head>
      <Component {...pageProps} />
    </>
  );
}
